import { Component } from "@angular/core";
import { AdvertisementComponent } from "./advertisement.component";
import { RouterModule, Routes } from "@angular/router";
import { AddNewAdvertisementDialogComponent } from "./add-new-advertisement/add-new-advertisement.component";
import { LicenseAuthGuard } from "../shared/license-auth.guard";

export const AdvertismentRoutes:Routes=[{
        path:'advertisement',
        children:[
            {path:'add-advertisement',component:AddNewAdvertisementDialogComponent}
        ],
        canActivate:[LicenseAuthGuard],
        canActivateChild:[LicenseAuthGuard],
        component:AdvertisementComponent,
}]
export const AdvertisementRoutingModule=RouterModule.forChild(AdvertismentRoutes);


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/advertisement/advertisement-routing.module.ts